import { useState, useEffect } from 'react';
import supabase from '../supabase/supabase';

export const useReleaseCalendar = () => {
  const [upcoming, setUpcoming] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      try {
        const now = new Date().toISOString();
        const { data, error: err } = await supabase
          .from('d2f_drops')
          .select(`
            id, title, genre, tags, cover_url, scheduled_at, created_at,
            artist:d2f_artists(id, name, slug)
          `)
          .eq('is_published', false)
          .not('scheduled_at', 'is', null)
          .gte('scheduled_at', now)
          .order('scheduled_at', { ascending: true })
          .limit(24);

        if (err) throw err;
        setUpcoming(data || []);
      } catch (e) {
        setError(e.message);
        setUpcoming([]);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, []);

  return { upcoming, loading, error };
};